import { adminFetch } from "./_client";
import type { DriverViewSlug, AdminDriver, DriverDetailData, BulkApproveResult, BlacklistEntry } from "./types";


export function fetchAdminDrivers(token: string, search = "", view: DriverViewSlug | "" = "", page = 1, limit = 20) {
  const params = new URLSearchParams({ page: String(page), limit: String(limit) });
  if (search) params.set("search", search);
  if (view) params.set("view", view);
  return adminFetch<{ drivers: AdminDriver[]; total: number; page: number; limit: number; view: DriverViewSlug }>(`/admin/drivers?${params}`, token);
}


export function fetchAdminDriver(token: string, id: number) {
  return adminFetch<DriverDetailData>(`/admin/drivers/${id}`, token);
}


export function approveDriver(token: string, id: number, payload: { note: string; template_slug?: string | null }) {
  return adminFetch<{ success: boolean; driver_id: number; license_verification_status: number }>(
    `/admin/drivers/${id}/approve`,
    token,
    { method: "POST", body: JSON.stringify(payload) },
  );
}


export function rejectDriver(token: string, id: number, payload: { note: string; template_slug?: string | null }) {
  return adminFetch<{ success: boolean; driver_id: number }>(
    `/admin/drivers/${id}/reject`,
    token,
    { method: "POST", body: JSON.stringify(payload) },
  );
}


export function reRequestDriverDocument(
  token: string,
  id: number,
  payload: { document_type: "licence"; note: string; template_slug?: string | null },
) {
  return adminFetch<{
    success: boolean;
    driver_id: number;
    kyc_id: number;
    request_created: boolean;
    notification_created: boolean;
    notification_persisted: true;
    email_delivery: { outcome: "sent" | "suppressed" | "failed" | "skipped"; reason?: string };
  }>(
    `/admin/drivers/${id}/re-request-document`,
    token,
    { method: "POST", body: JSON.stringify(payload) },
  );
}


export function bulkApproveDrivers(token: string, payload: { driver_ids: number[]; max_score: number; note: string }) {
  return adminFetch<BulkApproveResult>(
    `/admin/drivers/bulk-approve`,
    token,
    { method: "POST", body: JSON.stringify(payload) },
  );
}


export function fetchDriverDocumentUrl(token: string, driverId: number, path: string) {
  const params = new URLSearchParams({ path });
  return adminFetch<{ url: string }>(`/admin/drivers/${driverId}/document?${params}`, token);
}


export function fetchBlacklist(token: string, type = "", page = 1) {
  const params = new URLSearchParams({ page: String(page) });
  if (type) params.set("type", type);
  return adminFetch<{ entries: BlacklistEntry[]; total: number; page: number; limit: number }>( `/admin/blacklist?${params}`, token);
}


export function addBlacklistEntry(token: string, data: { entry_type: string; value: string; reason?: string }) {
  return adminFetch<BlacklistEntry>("/admin/blacklist", token, { method: "POST", body: JSON.stringify(data) });
}


export function removeBlacklistEntry(token: string, id: number) {
  return adminFetch<{ success: boolean }>( `/admin/blacklist/${id}`, token, { method: "DELETE" });
}
